import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ContactImage(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg width={width || 66.5} height={height || 66.5} viewBox="0 0 66.5 66.5">
      <path
        data-name="Path 10133"
        d="M1 7.693v50.614A6.691 6.691 0 007.693 65h50.614A6.712 6.712 0 0065 58.307V7.693A6.712 6.712 0 0058.307 1H7.693A6.691 6.691 0 001 7.693zm42.039 15.268A10.039 10.039 0 1133 12.922a10.026 10.026 0 0110.039 10.039zM12.922 49.732c0-6.693 13.386-10.374 20.078-10.374s20.078 3.681 20.078 10.374v3.346H12.922z"
        fill="#fee0c0"
        stroke="#fb972e"
        strokeWidth={2.5}
        transform="translate(2.25 1.189) translate(-2 -.939)"
      />
      <text
        data-name="\uF013"
        transform="translate(2.25 1.189) translate(47 56.061)"
        fill="#fff"
        stroke="#fb972e"
        strokeWidth={2.5}
        fontSize={21}
        fontFamily="SegoeUI, Segoe UI"
        letterSpacing="0.01em"
      >
        <tspan x={-6.778} y={0}>
          {"\uF013"}
        </tspan>
      </text>
    </svg>
  );
}
